export const FETCHING_USERREPRESENTATIVE = 'FETCHING_USERREPRESENTATIVE';
export const UPDATING_USERREPRESENTATIVE = 'UPDATING_USERREPRESENTATIVE';
export const AUTHENTICATING_USERREPRESENTATIVE = 'AUTHENTICATING_USERREPRESENTATIVE';
export const LINKING_USERREPRESENTATIVE = 'LINKING_USERREPRESENTATIVE';

